// src/pages/admin/AddImagePage.jsx

import React from "react";
import AddImage from "../../components/admin/add/AddImage";

const AddImagePage = () => {
  return (
    <div className="admin-page">
      <AddImage />
    </div>
  );
};

export default AddImagePage;
